import { SET_USER_INFO, SET_RESOURCE, SET_NOT_READ_SYSTEM_MESSAGE_COUNT } from '../mutation_type';
import selectPublic  from "@/helper/selectPublic";

const state = {
  userInfo: null,
  isImLogin:false,
  resource: {},
  notReadSystemMessageCount: 0,
};

// getters
const getters = {
  getUserInfo: state => { return { ...state.userInfo } },
  getResource: state => state.resource,
  getNotReadSystemMessageCount: state => state.notReadSystemMessageCount,
  getImLogin : state => state.isImLogin,
};

// mutations
const mutations = {
  [SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
    state.userInfo.appId = selectPublic.appIds[userInfo.brandId];
    state.userInfo.brandType = selectPublic.appIds[userInfo.brandId];
    state.userInfo.beanId = userInfo.accountName;
  },
  [SET_RESOURCE](state, resource) {
    state.resource = resource;
  },
  [SET_NOT_READ_SYSTEM_MESSAGE_COUNT](state, notReadSystemMessageCount) {
    state.notReadSystemMessageCount = notReadSystemMessageCount;
  },
  toggleIsLogin(state, isLogin) {
    state.isImLogin = typeof isLogin === 'undefined' ? !state.isImLogin : isLogin
  },
};

// actions
const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
